import { IPrice } from '../../../../../shared/i18n/price/IPrice';
import { getDifference } from '../../../../../shared/i18n/price/utils/getDifference';

export function getShouldProceedWithoutPay(
	originalTotalPrice: IPrice | undefined,
	totalPrice: IPrice,
): boolean {
	if (totalPrice.centAmount <= 0) {
		return true;
	}

	const priceDifference =
		originalTotalPrice && getDifference(originalTotalPrice, totalPrice);

	return priceDifference !== undefined && priceDifference.centAmount >= 0;
}
